import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { text, primary, background } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { rounded, spacing } from "@/theme/variables";
import examLearnerImg from "@/assets/images/exam_learner.png";

/**
 * Tips box component with mockExam tips.
 */
export const TipsBox: FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        gap: spacing.xxs,
        px: spacing.sm,
        py: spacing.xs,
        borderRadius: rounded.xs,
        border: `1px solid ${primary[500]}`,
        bgcolor: background.white,
        alignItems: "center",
      }}
    >
      {/* MockExam image */}
      <Box
        sx={{
          flex: "0 0 auto",
          width: 48,
          height: 42,
          borderRadius: rounded.xs,
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={examLearnerImg} alt="Mock Exam" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }} />
      </Box>
      <Stack gap={spacing.xxs} sx={{ flex: 1 }}>
        <Typography sx={{ ...typography.cap12, color: text.secondary, fontWeight: 500 }}>・ {t("mockExam.tips.tip1")}</Typography>
        <Typography sx={{ ...typography.cap12, color: text.secondary, fontWeight: 500 }}>・ {t("mockExam.tips.tip2")}</Typography>
        <Typography sx={{ ...typography.cap12, color: text.secondary, fontWeight: 500 }}>・ {t("mockExam.tips.tip3")}</Typography>
      </Stack>
    </Box>
  );
};
